module.exports = {"title":" Expert interviews and other materials"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/articles-list.en.json
// module id = 140
// module chunks = 0